export default {
  data() {
    return {
      filters: {
        dt_start: '',
        dt_finish: ''
      },
    }
  },

  methods   :{
    filterChanged: function (data, event) {
      this.filters = data;
    },
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/ArtistsMix.js
// module id = null
// module chunks = 